module.exports = __webpack_public_path__ + "img/telephone-forward.8f97e87b.svg";